function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { XS } from "components/core/new-button/button-component";
import PictureComponent from "components/core/picture/picture-component";
import CheckboxSVG from "segments/desktop/core-components/product-card/checkbox-icon";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import { StyledSelectableProductCard } from "segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/desktop-carousel-tags/selectable-product-card/selectable-product-card.scss";
import { BUTTON_CONFIG_BY_PRODUCT, PRODUCT_ID_TO_COLOR, PRODUCT_ID_TO_LOGO } from "../../consts";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
const SelectableProductCard = ({ cardAsset, useCases, productType, tag })=>/*#__PURE__*/ _jsxs(StyledSelectableProductCard, {
        className: "carousel-product-card",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "card-details",
                children: [
                    /*#__PURE__*/ _jsx(Paragraph, {
                        body: tag.tagText
                    }),
                    /*#__PURE__*/ _jsx(PictureComponent, {
                        className: "product-icon",
                        src: PRODUCT_ID_TO_LOGO[productType]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "picture-wrapper",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: cardAsset
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card-content",
                children: [
                    productType && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "title",
                                children: "Recommended product"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "product-logo-wrapper",
                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                    src: PRODUCT_ID_TO_LOGO[productType]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "use-cases-wrapper",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.map(({ useCase })=>/*#__PURE__*/ _jsxs("div", {
                                className: "use-case",
                                children: [
                                    /*#__PURE__*/ _jsx(CheckboxSVG, {}),
                                    useCase
                                ]
                            }, useCase))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "product-signup-wrapper",
                        children: /*#__PURE__*/ _jsx(SignupButton, _object_spread_props(_object_spread({
                            buttonSize: XS,
                            extraData: {
                                tag: tag === null || tag === void 0 ? void 0 : tag.tagText,
                                productType
                            }
                        }, BUTTON_CONFIG_BY_PRODUCT[productType]), {
                            buttonColor: PRODUCT_ID_TO_COLOR[productType],
                            withButtonArrow: false
                        }))
                    })
                ]
            })
        ]
    });
export default SelectableProductCard;
